module.exports = __webpack_public_path__ + "img/imagem-sobre-complexo-02.7707cbd1.png";